import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import SectionHeading from "../SectionHeading";
import { faqs } from "../../data/siteContent";
import { apiRequest } from "../../lib/api";

export default function FAQSection() {
  const [open, setOpen] = useState(0);
  const [items, setItems] = useState(faqs);
  useEffect(() => { let active = true; apiRequest('/public/faqs').then((response) => { if (active && response.data?.length) setItems(response.data.map((item) => ({ question: item.question, answer: item.answer }))); }).catch(() => {}); return () => { active = false; }; }, []);
  return (
    <section className="section-space bg-mist" id="faqs">
      <div className="container grid gap-14 lg:grid-cols-[.8fr_1.2fr] lg:gap-20">
        <div className="max-w-xl lg:sticky lg:top-28 lg:self-start">
          <SectionHeading
            eyebrow="Before you make a request"
            title="Know what to expect from the start."
            copy="See how requests are scoped, priced, tracked and completed, and how The Bridge keeps you informed when you are managing work from anywhere."
          />
        </div>
        <div className="space-y-3">
          {items.map((faq, index) => (
            <div
              key={faq.question}
              className="rounded-2xl border border-ink/10 bg-white"
            >
              <button
                type="button"
                onClick={() => setOpen(open === index ? -1 : index)}
                className="flex w-full items-center justify-between gap-5 p-5 text-left font-display font-bold text-ink"
              >
                <span>{faq.question}</span>
                <ChevronDown
                  size={18}
                  className={`shrink-0 text-ocean transition ${open === index ? "rotate-180" : ""}`}
                />
              </button>
              {open === index && (
                <p className="px-5 pb-5 text-sm leading-7 text-slate">
                  {faq.answer}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
